<template>
  <div class="join-us" :class="{english:lang=='EN'}">
    <Header ref="header" id="header"></Header>
    <div class="banner" ref="banner">
      <img class="img-fluid"
           :style="isMobile?{marginTop:'3.5rem'}:''"
           :class="isMobile?'visible-xs':'hidden-xs'"
           src="../assets/img/joinus/banner.png"
           ref="banner"
      >
    </div>

    <div style="width: 100%;" ref="operateOL" :class="{operateFixed:isOperateFixed}">
      <div class="hidden-xs">
        <div class="operate-ol">
          <div class="operate">
            <div class="caption">{{$t('joinUs.us')}}</div>
            <div class="tab-ul">
              <span v-for="item in tabs" @click="goAnchor(item)"
                    :class="{active:curMenu == item.label}">{{$t(item.name)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="operate-ol">
          <div class="operate">
            <div class="caption">{{$t('joinUs.us')}}</div>
            <div class="dropdown">
              <div class="dropdown-toggle" type="button" id="dropdownMenu4" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="true">
                {{$t(curMenuName)}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <ul class="dropdown-menu dropdown-ul dropdown-menu-right" aria-labelledby="dropdownMenu4">
                <li v-for="item in tabs" @click="goAnchor(item)">{{$t(item.name)}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <company-condition id="companyCondtion"></company-condition>
<!--    <company-activity id="companyActivity"></company-activity>-->
    <JobOffer id="jobOffer"></JobOffer>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from '@/components/common/Header'
  import Footer from '@/components/common/Footer'
  import CompanyCondition from '@/components/common/joinus/CompanyCondition'
  import CompanyActivity from '@/components/common/joinus/CompanyActivity'
  import JobOffer from '@/components/common/joinus/JobOffer'
  import {mapGetters} from 'vuex'

  export default {
    name: 'JoinUs',
    components: {
      Header,
      CompanyCondition,
      CompanyActivity,
      JobOffer,
      Footer
    },
    props: {},
    data () {
      return {
        isOperateFixed: false,
        curMenu: 'companyCondtion',
        curMenuName: 'joinUs.environment',
        tabs: [
          {
            label: 'companyCondtion',
            name: 'joinUs.environment'
          },
          // {
          //   label: 'companyActivity',
          //   name: 'joinUs.activities'
          // },
          {
            label: 'jobOffer',
            name: 'joinUs.position'
          }
        ]
      }
    },
    methods: {
      scrollEvent () {
        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$refs.header.setHeaderFixed(true)
          if (screenWidth >= 768) {
            if (scrollTop > this.$refs.banner.offsetHeight - this.$refs.operateOL.offsetHeight) {
              this.isOperateFixed = true
              $('#header').slideUp('fast')
            } else {
              this.isOperateFixed = false
              $('#header').slideDown('fast')
            }
          } else {
            if (scrollTop > this.$refs.banner.offsetHeight) {
              this.isOperateFixed = true
              $('#header').slideUp('fast')
            } else {
              this.isOperateFixed = false
              $('#header').slideDown('fast')
            }
          }
        } else {
          this.isOperateFixed = false
          $('#header').slideDown('fast')
          this.$refs.header.setHeaderFixed(false)
        }
        // 设置双向锚点
        this.setCurTab()
      },
      goAnchor (item) {
        let selector = item.label
        this.curMenu = selector
        this.curMenuName = item.name
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let scrollHeight = 0
        if (scrollTop <= this.$refs.operateOL.offsetTop) {
          scrollHeight = $('#' + selector).offset().top - this.$refs.operateOL.offsetHeight * 2 + 10
        } else {
          scrollHeight = $('#' + selector).offset().top - this.$refs.operateOL.offsetHeight + 10
        }
        $('html,body').animate({
          scrollTop: scrollHeight
        }, 300)
        return
      },

      setCurTab () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // 设置锚点双向绑定
        let idArr = ['companyCondtion', 'jobOffer']
        for (let i = 0; i < idArr.length; i++) {
          if (scrollTop >= $('#' + idArr[i]).offset().top - this.$refs.operateOL.offsetHeight) {
            this.curMenu = idArr[i]
            this.curMenuName = this.getMenuNameById(idArr[i])
          }
        }
        return
      },
      getMenuNameById (menuId) {
        let name = ''
        for (let i = 0; i < this.tabs.length; i++) {
          if (menuId == this.tabs[i].label) {
            name = this.tabs[i].name
          }
        }
        return name
      }
    },
    mounted () {
      $('html,body').scrollTop(0)
      this.setCurTab()
      window.addEventListener('scroll', this.scrollEvent)
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    computed: {
      ...mapGetters(['isMobile', 'lang']),
      getComponentName () {
        return 'JoinUs'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .operateFixed {
    position: fixed;
    top: 0;
    z-index: 1001;
    box-shadow: 0rem 0rem 0.75rem 0rem rgba(179, 193, 218, 0.41);
  }

  .join-us {
    background: #f3f6fb;

    .operate-ol {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #FFFFFF;
      border-bottom: 1px solid rgba(243, 246, 251, 1);

      .operate {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height:5rem;
        width: 100%;
        max-width: 75rem;

        .caption {
          font-size: 1.13rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 500;
          color: #333;
          line-height:5rem
        }

        .tab-ul {
          span {
            font-size:1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 500;
            color: #666;
            line-height: 5rem;
            margin: 0 0.8rem;
            cursor: pointer;
          }

          span:hover {
            color: #3292FF;
          }

          .active {
            color: #3292FF;
          }
        }
      }
    }

    .visible-xs {
      .operate-ol {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(243, 246, 251, 1);
        position: relative;

        .operate {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.5rem;
          width: 100%;
          max-width: 90%;
          border-bottom: 1px solid rgba(243, 246, 251, 1);
          position: relative;

          .caption {
            font-size: 1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight:400;
            color:#333;
            line-height:3.5rem
          }

          .el-dropdown-link:focus {
            outline: 0;
          }

          .el-dropdown-menu__item {
            text-align: center;
          }

          .dropdown-ul {
            margin-top: 0.5rem;
            width: 2rem;

            li {
              text-align: center;
              margin: 0.8rem 0;
            }
          }
        }
      }
    }
  }

  .english {
    .visible-xs {
      .dropdown-ul {
        margin-left: 0 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/JoinUs.vue